import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

const mapSearchSchema = z.object({
  style: z
    .enum([
      'explore',
      'night',
      'logistics',
      'logisticsNight',
      'satellite',
      'terrain',
    ])
    .optional(),
  layers: z.string().optional(),
  lat: z.coerce.number().optional(),
  lng: z.coerce.number().optional(),
  z: z.coerce.number().optional(),
  hidden: z.string().optional(),
})

export type MapSearchParams = z.infer<typeof mapSearchSchema>

export const Route = createFileRoute('/dashboard/fleet-map/')({
  head: () => ({ meta: [{ title: localizedPageTitle('fleetMap') }] }),
  component: FleetMapPage,
  validateSearch: mapSearchSchema,
})

export default function FleetMapPage() {
  useDocumentTitle('fleetMap')
  return <></>
}
